import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import statusService from "api/statusService";
import StatusBadge from "components/StatusBadge";
import { IStatus } from "dto/IStatus";
import { useContext, useEffect, useMemo, useRef, useState } from "react";

import tagsService from "api/tagsService";
import CaseIcon from "assets/icons/case.svg?react";
import DeskIcon from "assets/icons/book.svg?react";
import ModalLayout from "components/ModalLayout";
import PackageCaseModal from "components/PackageCaseModal";
import TagBadge from "components/TagBadge";
import { ITag } from "dto/ITag";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import MenuContext from "contexts/MenuContext";
import settingsContext, { IOptionType } from "contexts/SettingsContext";
import ActionsContext from "contexts/ActionsContext";
import EventInfoModal from "components/EventInfoModal";
import { IFeed } from "dto/IFeed";
import Popper from "components/Popper";
import DeskActiveModal from "components/DeskActiveModal";
import { ItemKind } from "dto/IKindItems";
import deskService from "api/deskService";

function stripHtml(html) {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  const decodedHtml = txt.value;

  return decodedHtml.replace(/<[^>]+>/g, "");
}

const TaskBox: FC<Props> = ({
  task,
  refetch,
}) => {
  const { data: statusesData } = statusService.useGetStatuses();
  const { data: tagsData } = tagsService.useGetTags();
  const statuses = useMemo(() => statusesData?.data ?? [], [statusesData]);
  const tags = useMemo(() => tagsData?.data ?? [], [tagsData]);
  const { mutate: setDesk } = deskService.useSetDesk();

  const findedStatuses = statuses?.find(
    (status: IStatus) => status.Id === task.StatusId
  );

  const findedTags = tags?.filter((t: ITag) =>
    (task.TagIds ?? []).includes(t.Id)
  );

  const [options, setOptions] = useState(false);

  const [, setShowStatus] = useState(false);
  const [showDesk, setShowDesk] = useState(false);

  const ref = useRef(null);
  const iconsWrapper = useRef(null);
  const [caseId, setCaseId] = useState<string | null>(null);

  const isCases = window.location.href.search("cases") !== -1;

  const { id, setId } = useContext(MenuContext);

  const handleRemoveFromDesk = () => {
    setDesk(
      {
        Items: [{ Id: task.Id, Kind: ItemKind.CalendarEvent }],
        Show: false,
      },
      {
        onSuccess: () => {
          refetch();
        },
      }
    );
  };

  useEffect(() => {
    if (id !== task.Id) {
      setOptions(false);
    }
  }, [id]);

  const { options: option } = useContext(settingsContext);

  const h = option.find((f) => f.Type === IOptionType.hoverMenu)?.Value;

  const useHoverOver = h === "true";

  const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);
  const [, setShowAfter] = useState(false);

  const { tasks } = useContext(ActionsContext);

  const [eventInfo, setEventInfo] = useState<IFeed | null>(null);
  const [position, setPosition] = useState([0, 0]);

  return (
    <div
      onMouseEnter={() => {
        if (useHoverOver) {
          setOptions(true);

          const t = setTimeout(() => {
            setShowAfter(true);
          }, 500);
          setTimer(t);
        }
      }}
      onMouseLeave={() => {
        if (useHoverOver) {
          setOptions(false);
          setShowAfter(false);
          if (timer) {
            clearTimeout(timer);
            setTimer(null);
          }
        }
      }}
      ref={ref}
      className={styles.container}
    >
      <div className={styles.color}></div>
      <div
        onClick={(e: any) => {
          const ele = e.target.tagName.toLowerCase();
          const button = e.target.outerHTML.search("button") !== -1;

          if (ele !== "div" || button) {
            return;
          }

          console.log("taski: ", task);
          const t = tasks?.find((a: any) => a.Id === task.Id);

          setEventInfo(t);
          setPosition([e.clientX, e.clientY]);
          // localStorage.setItem("action", JSON.stringify(t));
          // localStorage.setItem("actionType", "EVENT");
          // setModals({ ...modals, createTask: true, hide: false });
        }}
        className={styles.box}
      >
        <div className={styles.wrapper}>
          <div className={styles.left}>
            <div className={styles.name}>
              {/* @ts-ignore */}
              {task?.Title ?? task?.title}
            </div>
            <div className={styles.description}>
              {!!findedTags.length && (
                <div
                  onClick={() => setShowStatus(true)}
                  className={styles.badges}
                >
                  {findedTags.map((t: ITag) => (
                    <TagBadge tag={t} />
                  ))}
                </div>
              )}
              <div className={styles.note}>{stripHtml(task.Note ?? "")}</div>
            </div>
          </div>
          <div className={styles.right}>
            <div className={styles.icons} ref={iconsWrapper}>
              {findedStatuses && (
                <div
                  onClick={() => setShowStatus(true)}
                  className={styles.flags}
                >
                  <StatusBadge status={findedStatuses} onRemove={() => {}} />
                </div>
              )}
              {task?.IsDeskActive && (
                <DeskIcon
                  onClick={() => setShowDesk(!showDesk)}
                  className={styles.icon}
                />
              )}
              {task?.Case?.Id && !isCases && (
                <CaseIcon
                  onClick={() => setCaseId(task?.Case?.Id)}
                  className={styles.icon}
                />
              )}
              {!useHoverOver && (
                <div
                  onClick={() => {
                    setOptions(!options);
                    setId(task.Id);
                  }}
                  className={styles.hover}
                >
                  <FontAwesomeIcon icon={faEllipsisVertical} />
                </div>
              )}
            </div>
          </div>

          {showDesk && (
            <Popper
              anchorEl={iconsWrapper?.current}
              open={showDesk}
              setOpen={setShowDesk}
            >
              <DeskActiveModal
                onRemove={handleRemoveFromDesk}
                toggle={() => {
                  setShowDesk(false);
                }}
              />
            </Popper>
          )}
        </div>
      </div>

      {caseId && (
        <ModalLayout toggle={() => setCaseId(null)} refWrapper={iconsWrapper}>
          <PackageCaseModal CaseId={caseId} toggle={() => setCaseId(null)} />
        </ModalLayout>
      )}

      {eventInfo && (
        <EventInfoModal
          position={position}
          event={eventInfo}
          toggle={() => setEventInfo(null)}
          refetch={() => {
            refetch();
          }}
        />
      )}
    </div>
  );
};

export default TaskBox;
